/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import profileIcon from '../../assets/images/profile.png';
import profileIcon2x from '../../assets/images/profile@2x.png';
import { Overview, Segments, Reports } from './Tabs/index';
import { getClientLogo, fallbackImgFunc } from '../../utils/user';

const getAvatarProps = ogranizationName =>
  ogranizationName
    ? {
        src: getClientLogo(ogranizationName, '100x100'),
        onError: fallbackImgFunc
      }
    : {
        src: profileIcon,
        srcSet: `${profileIcon}, ${profileIcon2x} 2x`
      };

const ProfileHeader = props => {
  return (
    <div className="user-profile-header">
      <div className="user-profile-avatar">
        <img
          className="img-responsive"
          alt="User Profile"
          {...getAvatarProps(props.organization)}
        />
      </div>
      <div className="user-profile-info">
        <div className="user-profile-info-username">{props.username}</div>
        <div className="user-profile-info-organizationName">
          {props.organization}
        </div>
      </div>
    </div>
  );
};

const UserProfile = ({
  user,
  filters,
  reportActions,
  segmentActions,
  userActions,
  segmentConfig,
  segmentId,
  segmentName,
  reports
}) => {
  const [selected, setSelected] = useState('overview');

  const selectNavItem = item => {
    if (!item.disabled) {
      setSelected(item.name);
    }
  };

  useEffect(() => {
    reportActions.fetchReportList(user.userId);
    document.title = 'My Profile | CVM Insights';
  }, []);

  const items = [
    {
      name: 'overview',
      disabled: false,
      className: 'user-data-nav-item'
    },
    {
      name: 'reports',
      disabled: false,
      className: 'user-data-nav-item'
    },
    {
      name: 'segments',
      disabled: false,
      className: 'user-data-nav-item'
    },
    {
      name: 'default filters',
      disabled: true,
      className: 'user-data-nav-item disabled'
    },
    {
      name: 'favorites',
      disabled: true,
      className: 'user-data-nav-item disabled'
    }
  ];
  return (
    <div>
      <ProfileHeader
        username={user.username}
        organization={user.organization}
      />
      <div className="user-data-wrapper">
        <div className="user-data-nav">
          {items.map((i, o) => (
            <React.Fragment key={i.name}>
              {o !== 0 && '|'}
              <button
                key={i.name}
                onClick={() => selectNavItem(i)}
                onKeyDown={() => selectNavItem(i)}
                className={`${i.className} ${
                  selected === i.name ? 'selected' : ''
                }`}
              >
                {i.name}
              </button>
            </React.Fragment>
          ))}
        </div>
        {selected === 'overview' && (
          <Overview user={user} updateUser={userActions.updateUser} selected />
        )}
        {selected === 'segments' && (
          <Segments
            segments={get(filters, 'options.segments', [])}
            onSave={segmentActions.saveAudienceSegment}
            updateFilterOptions={segmentActions.updateFilterOptions}
            deleteSegment={segmentActions.deleteAudienceSegment}
            config={segmentConfig}
            name={segmentName}
            id={segmentId}
          />
        )}
        {selected === 'reports' && (
          <Reports
            userId={user.userId}
            reports={reports}
            fetchReportList={reportActions.fetchReportList}
          />
        )}
      </div>
    </div>
  );
};

UserProfile.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired,
    organization: PropTypes.string
  }).isRequired,
  filters: PropTypes.shape({}).isRequired,
  segmentActions: PropTypes.shape({
    saveAudienceSegment: PropTypes.func.isRequired,
    updateFilterOptions: PropTypes.func.isRequired,
    deleteAudienceSegment: PropTypes.func.isRequired
  }).isRequired,
  reportActions: PropTypes.shape({
    fetchReportList: PropTypes.func.isRequired
  }).isRequired,
  userActions: PropTypes.shape({
    updateUser: PropTypes.func.isRequired
  }).isRequired,
  reports: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  segmentConfig: PropTypes.shape({}).isRequired,
  segmentId: PropTypes.string,
  segmentName: PropTypes.string.isRequired
};

UserProfile.defaultProps = {
  segmentId: null
};

export default UserProfile;
